module.exports = __webpack_public_path__ + "static/img/comp_paint1.3224405.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/drawing_painting/comp_paint1.jpg
// module id = FV7l
// module chunks = 1